/** Text found in an image, with translations into the reader's language. */
import { useEffect, useState } from 'react';
import { api, ApiError } from '../api.ts';
import { useT } from '../i18n.ts';
import { Dialog } from './Dialog.tsx';

interface Result {
  lines: Array<{ original: string; translation: string }>;
  note: string;
}

export function ImageTextDialog({ mediaId, onClose }: { mediaId: string; onClose: () => void }) {
  const t = useT();
  const [data, setData] = useState<Result | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    api<Result>('POST', `/api/media/${mediaId}/text`, undefined, { timeoutMs: 120_000 })
      .then(setData)
      .catch((err) => setError(err instanceof ApiError && err.code === 'budget_exceeded' ? t('budgetExceeded') : t('imgTextFailed')));
  }, [mediaId, t]);
  return (
    <Dialog title={t('imgTextTitle')} onClose={onClose}>
      <img className="imgtext-preview" src={`/api/media/${mediaId}`} alt="" />
      {!data && !error && <p className="muted" role="status"><span className="spinner" aria-hidden="true" /> {t('imgTextWorking')}</p>}
      {error && <p className="form-error" role="alert">{error}</p>}
      {data && (
        <div className="stack">
          {data.note && <p className="muted small">{data.note}</p>}
          {data.lines.length === 0 ? (
            <p>{t('imgTextNone')}</p>
          ) : (
            <table className="table imgtext">
              <tbody>
                {data.lines.map((l, i) => (
                  <tr key={i}>
                    <td className="muted">{l.original}</td>
                    <td>{l.translation}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <p className="muted small">{t('sumDisclaimer')}</p>
          <div className="row">
            <button className="btn small" onClick={() => void navigator.clipboard?.writeText(data.lines.map((l) => `${l.original}\t${l.translation}`).join('\n'))}>{t('copyText')}</button>
          </div>
        </div>
      )}
    </Dialog>
  );
}
